<template>
  <div class="ticketOrder">
    <div class="container">
      <div class="titleNav">
        <router-link to="/cityExpress">我要下单</router-link> /
        <router-link to="/ticket">票务服务</router-link> /
        <router-link to="/ticketOrder">确认订单</router-link>
      </div>
      <div class="content">
        <div class="top">
          <table>
            <tr>
              <td>出行方式</td>
              <td><span class="trip">{{ticketInfo.travelMode}}</span>{{seatType}}</td>
            </tr>
            <tr v-if="ticketInfo.departureDate">
              <td>出行日期</td>
              <td>{{ticketInfo.departureDate.replace(/00:00:00/g, '')}}</td>
            </tr>
            <tr>
              <td>出发地</td>
              <td>{{ticketInfo.departurePlace}}</td>
            </tr>
            <tr>
              <td>目的地</td>
              <td>{{ticketInfo.destinationPlace}}</td>
            </tr>
            <tr>
              <td>车次</td>
              <td>{{ticketInfo.trainNumber}}</td>
            </tr>
          </table>
        </div>
        <div class="middle">
          <div class="left">
            <label for="">
              <span>乘客：</span>
              <div class="fare">
                <div class="isHave"  v-if="isInput">
                  <input type="text" placeholder="选择已有乘客" readonly @click="showPassenger" v-model="info.name">
                  <img src="../../../assets/images/login/xiasanjiao.png" alt="">
                </div>
                <input type="text" placeholder="请输入乘客名字" v-model="info.name" v-else>
                <button @click="showInput">{{isInput ? '新建' : '已有乘客'}}</button>
                <ul class="down" v-if="isShow">
                  <li v-for="(item, index) in passengerList" :key="item.id" @click="passengerItem($event, item)">{{item.name}}</li>
                </ul>
              </div>
            </label>
            <label for="">
              <span>乘客手机号：</span>
              <input type="tel"  :disabled="isDisabled" placeholder="请输入乘客手机号码（必填）" v-model="info.phone">
            </label>
            <label for="" class="card">
              <span>乘客身份证号：</span>
              <input type="tel" :disabled="isDisabled" placeholder="请输入乘客身份证号码（必填）" v-model="info.idCard">
            </label>
            <label for="">
              <span>账号信息：</span>
              <input type="tel"  :disabled="isDisabled" placeholder="请输入12306等出行账号信息（选填）" v-model="info.accountInfo">
            </label>
            <label for="" class="remark">
              <span>备注信息：</span>

              <textarea type="tel" placeholder="请输入备注信息" v-model="info.description"></textarea>
            </label>
            <label for="">
              <span>设置服务有效期：</span>
              <date-time @time="times" :type="type"/>
              <span class="hint" @click="toHint">？</span>
            </label>
            <label for="">
              <span>付款方式：</span>
              <div class="fare">
                <input type="tel" placeholder="请选择" readonly @click="showPayType" v-model="payType">
                <ul class="down" v-if="isShowWay">
                  <li @click="typeItem($event, 1)">先支付服务费，抢到票支付车票费</li>
                  <li @click="typeItem($event, 2)">预支付车票费和服务费</li>
                </ul>
              </div>
            </label>
            <label for="" class="remark" v-if="info.paytype == 2 ">
              <span>车费预估：</span>
              <input type="number" placeholder="请输入车票预估金额（必填）" v-model="ticketFee">
            </label>
          </div>
          <div class="right">
            <raise-price />
          </div>
        </div>
        <div class="bottom">
          <router-link :to="{name: 'RichText', query: {code: '011'}}" class="plain">价格说明</router-link>
          <price-explain />
          <button @click="pay">支付</button>
        </div>
      </div>
    </div>
    <pay-way v-if="isShowPay" @close="showPay" />
  </div>
</template>

<script>
import {reqPassengerChange} from '../../../api'
import RaisePrice from '../../../components/Courier/RaisePrice'
import PriceExplain from '../../../components/Courier/PriceExplain'
import DateTime from '../../../components/Time'
import PayWay from '../../../components/Pay/PayWay'
import {reqPassenger, reqOrderTicket, reqCountServiceFee} from '../../../api'
import {formatDate} from '../../../utils/date'
import {mobiles, idCard} from '../../../utils/phone'
import {mapState} from 'vuex'
export default {
  data() {
    return {
      isDisabled:false,
      ticketInfo: {},
      info: {
        passengerId: '',
        name: '',

        phone: '', // 手机号
        idCard: '', // 身份证
        description: '', // 备注
        accountInfo: '', // 账户信息
        serviceDate: '', // 服务有效期
        paytype: '', // 付款方式
        ticketFee: '' // 预估金额
      },
      ticketFee: '', // 预估金额
      payType: '', // 付款方式
      seatType: '',
      isShow: false, // 显示乘客
      isShowWay: false, // 显示付款方式
      isInput: true,
      passengerList: [], // 乘客列表
      isShowPay: false, // 显示支付宝
      seatIds: '', // 座位id
      type: 'datetime' // 时间类型
    }
  },
  activated() {
    // 判断vuex有木有orderInfo
    if(JSON.stringify(this.$store.state.ticketInfo) === '{}'){
      console.log(102)
      this.$router.replace('/courier/ticket')
    }else {
      console.log(this.$store.state.ticketInfo)
      this.ticketInfo = this.$store.state.ticketInfo
      this.info.name = this.ticketInfo.name
      this.info.phone = this.ticketInfo.phone
      this.info.idCard = this.ticketInfo.idCard
      this.info.description = this.ticketInfo.description
      this.info.accountInfo = this.ticketInfo.accountInfo
      this.info.serviceDate = this.ticketInfo.serviceDate
      this.info.paytype = this.ticketInfo.paytype
      console.log("这是啥很猛",this.ticketInfo.seatType)
       this.seatType=""
        this.seatIds=""
      this.ticketInfo.seatType.forEach((item, index) => {
        if(index === this.ticketInfo.seatType.length-1){
          this.seatType += item.name
          this.seatIds += item.id
        }else{
          this.seatType += item.name + ','
          this.seatIds += item.id + ','
        }
      })
    }
    // 计算价格
    console.log(this.ticketInfo.departureDate)
    let query =  `?seatIds=${this.seatIds}&times=${this.ticketInfo.departureDate}`
    reqCountServiceFee(query).then(res => {
      if(res.code === 200) {
        this.$store.dispatch('getFee', res.data.bussData)
      }
    })
    // 获取乘客列表
    reqPassenger().then(res => {
      if(res.code === 200){
        this.passengerList = res.data.bussData
      }
    })
  },
  methods: {
    // 获取时间
    times (time) {
      let date = new Date(time)
      this.info.serviceDate = formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    toHint() {
      this.$router.push({name: 'RichText', query: {code: '003'}})
    },
    // 显示乘客
    showPassenger () {
      this.isShow = !this.isShow
    },
    // 显示付款方式
    showPayType () {
      this.isShowWay = !this.isShowWay
    },
    // 点击乘客显示在input框
    passengerItem (e, item) {
      this.isDisabled=true
      this.info.passengerId = item.id
      this.info.name = e.target.innerText
      this.info.idCard = item.idCard
      this.info.phone = item.mobile
      this.info.accountInfo = item.travelNo
      this.isShow = !this.isShow

    },
    // 点击付款方式显示在input框
    typeItem (e, i) {
      if(i == 1) {
        this.$store.dispatch('clearBudget')
        this.ticketFee = ''
      }
      this.info.paytype = i
      this.payType = e.target.innerText
      this.isShowWay = !this.isShowWay
    },
    // 点击新增按钮
    showInput () {
      this.isDisabled=false
      this.isShow = false
      this.isInput = !this.isInput
      this.info.passengerId = ''
      this.info.name = ''
      this.info.idCard = ''
      this.info.phone = ''
      this.info.travelNo = ''
    },
    // 显示支付方式
    showPay () {
      this.isShowPay = !this.isShowPay
    },
    // 支付
    pay() {
      if(!this.info.name) {
        this.$message({
          message: '乘客不能为空',
          type: 'error'
        })
      } else if(!this.info.phone) {
        this.$message({
          message: '乘客手机号不能为空',
          type: 'error'
        })
      } else if(!mobiles(this.info.phone)) {
        this.$message({
          message: '乘客手机号不正确',
          type: 'error'
        })
      } else if(!this.info.idCard) {
        this.$message({
          message: '乘客身份证号不能为空',
          type: 'error'
        })
      } else if(!idCard(this.info.idCard)) {
        this.$message({
          message: '乘客身份证号不正确',
          type: 'error'
        })
      } else if(!this.info.paytype) {
        this.$message({
          message: '请选择付款方式',
          type: 'error'
        })
      } else if(this.info.paytype == 2 && this.info.ticketFee == '' ) {
        this.$message({
          message: '请输入车票预估金额',
          type: 'error'
        })
      }else {
        const {departureDate, departurePlace, destinationPlace, seatType, trainNumber, travelMode} = this.ticketInfo
        const {passengerId, name, phone, idCard, description, accountInfo, serviceDate , paytype, ticketFee} = this.info
        // addFee: '', // 加价
        //   couponFee: '', // 优惠价
        //   couponsubid: '', // 优惠券id
        console.log(departureDate)
        let str = ''
        seatType.forEach((item, index) => {
          if(index == seatType.length-1){
            str += item.id
          } else {
            str += item.id + ','
          }
        })
        let body = {}
        if(passengerId) {
          body = {
            departureDate,
            departurePlace,
            seatType: str,
            destinationPlace,
            trainNumber,
            travelMode,
            passengerId,
            passengerType: 2,
            description,
            accountInfo,
            serviceDate,
            paytype,
            origin:1,
            ticketFee,
            addFee: this.addFee,
            couponFee: this.amount.amount,
            couponsubid: this.amount.couponId
          }
        } else {
          body = {
            departureDate,
            departurePlace,
            seatType: str,
            destinationPlace,
            trainNumber,
            travelMode,
            passengerType: 1,
            name,
            phone,
            idCard,
            description,
            accountInfo,
            serviceDate,
            paytype,
            origin:1,
            ticketFee,
            addFee: this.addFee,
            couponFee: this.amount.amount,
            couponsubid: this.amount.couponId
          }
          //  如果是新的用户信息 就新增

          //  reqPassengerChange({
          //    mobile:body.phone,
          //    travelNo:body.accountInfo,
          //    ...body
          //  }).then(res => {
          //   if (res.code === 200) {
          //     console.log(res)
          //   }
          // })
        }

        reqOrderTicket(body).then(res => {
          if(res.code === 200) {
            this.showPay()
            this.$store.dispatch('getOrderInfo', res.data.bussData)
          }
        })
      }
    }
  },
  watch: {
    ticketFee() {
      this.info.ticketFee = this.ticketFee
      this.$store.dispatch('getBudget', this.ticketFee)
    }
  },
  computed: {
    ...mapState(['addFee', 'amount'])
  },
  deactivated() {
    // this.$store.dispatch('clearTicketInfo')
  },
  components: {
    RaisePrice,
    PriceExplain,
    DateTime,
    PayWay
  }
}
</script>

<style scoped lang="less" type="text/less">
.ticketOrder{
  margin-bottom: 70px;
  .titleNav{
    margin:30px 0 41px;
  }
  .content{
    padding:30px;
    box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
    .top{
      padding-bottom: 40px;
      border-bottom: 1px solid #e1e1e1;
      table{
        td{
          border:1px solid #e1e1e1;
          line-height: 40px;
          &:first-of-type{
            width: 129px;
            text-indent: 21px;
          }
          &:last-of-type{
            width: 475px;
            text-indent: 31px;
          }
          .trip{
            margin-right: 10px;
          }
        }
      }
    }
    .middle{
      display: flex;
      justify-content: space-between;
      margin-top:40px;
      padding-bottom: 30px;
      border-bottom: 1px solid #e1e1e1;
      .left{
        label{
          display: flex;
          margin-bottom: 20px;
          line-height: 40px;
          span{
            width: 112px;
            margin-right: 5px;
            text-align: right;
          }
          input{
            width: 340px;
            height: 40px;
            border:1px solid #e1e1e1;
            box-sizing: border-box;
            border-radius: 4px;
            text-indent: 10px;
            &::-webkit-input-placeholder{
              color:#c0c4cc;
            }
          }
          &.sex{
            align-items: center;
            p{
              margin-right:39px;
              img{
                width: 20px;
                height: 20px;
                margin-right: 11px;
                vertical-align: middle;
                cursor: pointer;
              }
            }

          }
          &.card{
            margin-bottom: 10px;
          }
          &.remark{
            textarea{
              width: 340px;
              height: 100px;
              resize: none;
              border:1px solid #e1e1e1;
              text-indent: 10px;
              &::-webkit-input-placeholder{
                color:#c0c4cc;
              }
            }
          }
          button{
            width: 100px;
            height: 40px;
            background: #2FA1DE;
            color:#fff;
            border:none;
            border-radius: 4px;
            cursor: pointer;
          }
          .fare{
            position: relative;
            display: flex;
            .isHave{
              position: relative;
              img{
                position: absolute;
                top: 14px;
                right: 15px ;
              }
            }
            input{
              cursor: pointer;
            }
            .down{
              position: absolute;
              top: 42px;
              left: 0;
              width: 100%;
              background: #fff;
              box-shadow: 0px 3px 21px 0px rgba(0, 0, 0, 0.25);
              li{
                border-bottom: 1px #e1e1e1 dashed;
                text-indent: 10px;
                cursor: pointer;
              }
            }
          }

        }
        .infuse{
          color:#999;
          margin-left:119px;
          margin-bottom: 20px;
        }
        .hint{
          width: 26px;
          height: 26px;
          margin:7px 10px;
          background: #61aee6;
          color: #ffffff;
          line-height: 26px;
          border-radius: 50%;
          font-weight: 700;
          font-size: 18px;
          cursor: pointer;
        }
      }
      .right{

      }
    }
    .bottom{
      padding-top:29px;
      .plain{
        color:#2FA1DE;
        text-decoration: underline;
      }
      button{
        width: 332px;
        height: 48px;
        margin:30px 0 19px 237px;
        border:none;
        background: #61aee6;
        color:#fff;
        border-radius: 24px;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Courier/Ticket/TicketOrder.vue